<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao-contrato
            :titulo="'Contratante'"
            :descricao="'Aqui é possível visualizar os dados do contratantes validados com a RFB'"
            :alterar-informacao="true"
            :item="valueInner.alteracaoContratante"
            :mensagem-alerta="true"
            @alterar-dados="alterarDadosContratante"
          >
            <template slot="complemento-numero">
              <div class="circle">
                1
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>

      <div
        :class="['mb-1',{'carregando-dados': !valueInner.carregado}]"
        style="position: relative;"
      >
        <div
          v-if="tipoProposta === 'transferencia' && !filial && (valueInner.empresas.length > 0 && !valueInner.empresas.some(som => som.matrizFilial === 'Matriz'))"
          class="aviso-pre-geracao"
        >
          Atenção: em propostas de transferência de Matriz deve haver obrigatoriamente um CNPJ de Matriz informado!
        </div>
        <div
          v-if="avisoCnpjNaoFilial()"
          class="aviso-pre-geracao"
        >
          Atenção: esse CNPJ não pertence a filial!
        </div>
        <div
          v-for="(empresa, $index) in valueInner.empresas"
          :key="$index"
        >
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="4">
                  <b-form-group label="CNPJ">
                    <b-input-group>
                      <inscricao-federal
                        v-model="empresa.inscricao"
                        :value="empresa.inscricao"
                        :tipo-inscricao="'cnpj'"
                        :disabled="!dadosContratante && !habilitarCampo"
                        @change="mudadoCNPJ(empresa)"
                      />
                      <b-input-group-append>
                        <b-button
                          v-b-tooltip.hover
                          title="Busca dados da RFB"
                          :variant="empresa.erroNavegacao || empresa.atualizar ? 'danger' : 'primary'"
                          style="float:right"
                          :disabled="(!empresa.erroNavegacao && !dadosContratante) && !habilitarCampo"
                          @click="buscarDados(empresa.inscricao, empresa.empresaId)"
                        >
                          <feather-icon
                            v-if="!empresa.erroNavegacao && !empresa.atualizar"
                            icon="CheckIcon"
                          />
                          <feather-icon
                            v-if="(empresa.erroNavegacao || empresa.atualizar)"
                            icon="RotateCwIcon"
                          />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Razão Social">
                    <b-form-input
                      v-model="empresa.nomeEmpresarial"
                      :disabled="true"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Tipo">
                    <b-form-input
                      v-model="empresa.matrizFilial"
                      :disabled="true"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <small
                v-if="empresa.erroNavegacao"
                class="text-danger"
              >Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!</small>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="mt-2">
        <b-col>
          <divisoria-descricao-contrato
            :titulo="'Sócios'"
            :descricao="'Aqui você pode adicionar os sócios com suas informações detalhadas'"
            :alterar-informacao="tipoProposta === 'transferencia' && filial"
            :item="valueInner.alteracaoContratante"
            @alterar-dados="alterarDadosCNPJ"
          >
            <template slot="complemento-numero">
              <div class="circle">
                2
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>

      <b-row v-if="filial">
        <b-col cols="12">
          <b-form-group>
            <b-row>
              <b-col cols="4">
                <b-input-group>
                  <inscricao-federal
                    v-model="valueInner.inscricaoCNPJMatriz"
                    :value="valueInner.inscricaoCNPJMatriz"
                    :tipo-inscricao="'cnpj'"
                    :disabled="!dadosCNPJMatriz && !habilitarCampo"
                    @change="mudadoCNPJ(valueInner)"
                  />
                  <b-input-group-append>
                    <b-button
                      v-b-tooltip.hover
                      title="Busca dados da RFB"
                      :variant="valueInner.erroNavegacaoMatriz || valueInner.atualizar ? 'danger' : 'primary'"
                      style="float:right"
                      :disabled="(!validarRaizCNPJ || (!valueInner.inscricaoCNPJMatriz || valueInner.inscricaoCNPJMatriz === '') || (!dadosCNPJMatriz)) && !habilitarCampo"
                      @click="buscarSocios(valueInner.inscricaoCNPJMatriz)"
                    >
                      <feather-icon
                        v-if="!buscaSocios"
                        icon="SearchIcon"
                      />
                      <feather-icon
                        v-if="!valueInner.erroNavegacaoMatriz && buscaSocios"
                        icon="CheckIcon"
                      />
                      <feather-icon
                        v-if="valueInner.erroNavegacaoMatriz && buscaSocios"
                        icon="RotateCwIcon"
                      />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <small
                  v-if="valueInner.erroNavegacaoMatriz"
                  class="text-danger"
                >
                  Não foi possível concluir a busca de dados na RFB, verifique o CNPJ informado e tente novamente!
                </small>
                <small
                  v-if="valueInner.socios.some(som => som.veioDoHub) && validarRaizCNPJ && !dadosCNPJMatriz"
                  class="text-success"
                >Busca de dados importada do Honorarium</small>
                <small
                  v-else-if="valueInner.socios.some(som => som.veioDoRFB) && validarRaizCNPJ && !dadosCNPJMatriz"
                  class="text-success"
                >
                  Busca de dados importada da RFB!</small>
                <small
                  v-if="!validarRaizCNPJ"
                  class="text-danger"
                >Validação de raiz: 8 primeiros dígitos devem ser iguais</small>
              </b-col>
              <i>
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
                Informe o CNPJ da Matriz para que o sistema realize a importação dos sócios
              </i>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <div
        :class="['mb-1',{'carregando-dados': !valueInner.carregado}]"
        style="position: relative;"
      >
        <div
          v-for="(socio, $index) in valueInner.socios"
          :key="$index"
        >
          <socio-empresa
            :ref="`socio${socio.code}`"
            :socio="socio"
            :desabilitar-nome="(socio.veioDoHub && socio.dadosSocio) || !socio.dadosSocio && !habilitarCampo"
            :mostrar-ocultar="true"
            :disabled="(socio.veioDoHub) || ((!socio.dadosSocio && ((filial && !valueInner.primeiraBuscaMatriz) || (valueInner.enviadoParaAnalise))) && !habilitarCampo) || (!habilitarCampo && !socio.dadosSocio)"
            :showinfo="true"
            :habilitar-campo="habilitarCampo"
            :desabilita-anexo="!socio.dadosSocio && !habilitarCampo"
            :lista-emails="valueInner.socios"
            @adicionar-item="adicionarItem($event)"
            @remover-item="removerItem($index)"
            @editar-socio="alterarDadosSocio"
            @ocultar-socio="ocultarSocioPregeracao"
          />
        </div>
      </div>
      <certificado-e-anexo
        ref="anexos"
        v-model="valueInner.anexosECertificado"
        :pre-geracao-id="valueInner.id"
        :desabilitar-campos="valueInner.enviadoParaAnalise || !habilitarCampo"
      />
      <b-row class="mt-2">
        <b-col>
          <divisoria-descricao-contrato
            :titulo="'Outras informações'"
            :descricao="'Informe a data de início da Responsabilidade Técnica do escritório e o e-mail para recebimento dos boletos e NFs'"
            :alterar-informacao="true"
            :item="valueInner.altercaoDataInicio"
            @alterar-dados="alterarDadosDataInicio"
          >
            <template slot="complemento-numero">
              <div class="circle">
                5
              </div>
            </template>
          </divisoria-descricao-contrato>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <div style="display: flex">
            <div>
              <legend style="font-size: 14px;">
                Data de início no Escritório Contábil</legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Aqui deve ser informado a data de início no escritório contábil, essa data é o início da Responsabilidade Técnica da contabilidade."
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <validation-provider
            #default="{ errors }"
            rules="required"
            :name="'Data de início'"
          >
            <data-input
              v-model="valueInner.dataInicio"
              :disabled="(valueInner.enviadoParaAnalise && !dadosDataInicio && !habilitarCampo) || (!habilitarCampo && !dadosDataInicio)"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
          <loading
            :is-loading="isLoading"
            :cancelar-upload="cancelarBusca"
            :show-message="'Prezado, estamos buscando os dados. Aguarde!'"
          />
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12">
          <email-input
            :value="valueInner.emailsBoletosNFs"
            :require="!pendenteAnalise"
            :disabled="((valueInner.enviadoParaAnalise && !dadosDataInicio) && !habilitarCampo) || (!habilitarCampo && !dadosDataInicio)"
            @input="adicionarEmail($event)"
          />
        </b-col>
      </b-row>
      <div v-if="existeMaisDeUmContratante">
        <b-row
          v-if="!filial"
          class="mt-1"
        >
          <b-col :cols="habilitarBotaoSalvarFaturamento ? '10' : '12'">
            <b-form-group label="De que forma deve ser faturado e enviado os boletos?">
              <validation-provider
                #default="{ errors }"
                rules="required"
                :name="'Forma de faturamento'"
              >
                <b-select
                  v-model="valueInner.eTipoFaturamentoBoletos"
                  :options="[{ value: 1, text: 'Separado por CNPJ'}, { value: 2, text: 'Consolidado na Matriz' }]"
                  :disabled="(valueInner.enviadoParaAnalise && !dadosDataInicio) && !habilitarCampo"
                />
                <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="habilitarBotaoSalvarFaturamento"
            cols="auto"
          >
            <b-btn
              variant="primary"
              size="sm"
              style="margin-top: 2.3rem;"
              :disabled="(valueInner.enviadoParaAnalise && !dadosDataInicio) && !habilitarCampo"
              @click="salvarEscolhaFaturamento"
            >
              Salvar
            </b-btn>
          </b-col>
        </b-row>
        <b-row
          v-if="filial || valueInner.eTipoFaturamentoBoletos === 1"
          :class="{'mt-1': filial}"
        >
          <b-col cols="12">
            <span
              class="link-rateio"
              @click="abrirRateioValores"
            >Rateio de valores para Omie (Clique aqui)</span>
            <font-awesome-icon
              :icon="faExternalLinkAlt"
              class="ml-50"
              style="color: #0c26df !important;"
            />
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-1">
        <b-form-group
          label="Descrição (opcional)"
          class="col-12"
        >
          <b-textarea
            v-model="valueInner.descricao"
          />
        </b-form-group>
      </b-row>
      <template-contrato-proposta
        :value="valueInner"
        :proposta-valor="propostaValor"
        :proposta-template="propostaTemplate"
        :proposta-id="propostaId"
        :habilitar-campo="habilitarCampo"
        :proposta-contrato="propostaContrato"
        @contrato-alterado="$emit('contrato-alterado', $event)"
      />
    </b-col>
    <rateio-valor-contrato
      ref="rateioValorContrato"
      :justificativa="valueInner.altercaoDataInicio ? valueInner.altercaoDataInicio.justificativa : ''"
    />
  </b-row>
</template>

  <style lang="scss">
  .circle {
    width: 25px;
    height: 25px;
    line-height: 25px;
    border: 1px solid #5e5873;
    border-radius: 50%;
    text-align: center;
    color: #5e5873;
    display: inline-block;
  }

  .desabilitar-inputs {
    pointer-events: none;
  }

 .link-rateio {
  text-decoration: underline #0c26df;
  color: #0c26df;
  cursor: pointer;
}
  </style>

<script>
import { mapGetters } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle, faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons'
import { generateCode } from '@core/utils/utils'
import { ValidationProvider } from 'vee-validate'
import apiPreGeracao from '@/app-modulo/comercial/cadastro-proposta/shared/components/pre-geracao-contrato-proposta/services/api'

export default {
  name: 'TransferenciaMatrizEFilial',
  components: {
    FontAwesomeIcon,
    ValidationProvider,
    DivisoriaDescricaoContrato: () => import('@/shared/components/divisoria-descricao-contrato/DivisoriaDescricaoContrato.vue'),
    CertificadoEAnexo: () => import('../certificado-e-anexos/CertificadoEAnexos.vue'),
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    SocioEmpresa: () => import('@/shared/components/socio-empresa-contrato/SocioEmpresaContrato.vue'),
    TemplateContratoProposta: () => import('../template-contrato-proposta/TemplateContratoProposta.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    InscricaoFederal: () => import('@/shared/components/inscricao-federal/InscricaoFederal.vue'),
    EmailInput: () => import('@/@pilar/components/email-input/EmailInput.vue'),
    RateioValorContrato: () => import('../rateio-valor-contrato/RateioValorContrato.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    filial: {
      type: Boolean,
      default: false,
    },
    habilitarCampo: {
      type: Boolean,
      default: false,
    },
    propostaContrato: {
      type: String,
      default: '',
    },
    tipoProposta: {
      type: String,
      default: '',
    },
    propostaValor: {
      type: Number,
      default: 0,
    },
    propostaTemplate: {
      type: String,
      default: '',
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    pendenteAnalise: {
      type: Boolean,
      default: false,
    },
    dadosSocio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faExternalLinkAlt,
      buscaSocios: false,
      faQuestionCircle,
      isLoading: false,
      dadosContratante: false,
      dadosCNPJMatriz: false,
      dadosDataInicio: false,
      valueInner: {
        emailsBoletosNFs: [],
        realizadoBusca: true,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          cpf: null,
          veioDoRFB: false,
          dadosSocio: false,
          tipoInscricao: 'cpf',
          ocultarDoContrato: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
          atualizarDados: false,
          code: generateCode(),
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
        },
        inscricaoCNPJMatriz: null,
        erroNavegacaoMatriz: false,
        primeiraBuscaMatriz: false,
      },
      invalidTags: [],
      duplicateTags: [],
    }
  },
  computed: {
    ...mapGetters('proposta', ['existeMaisDeUmContratante', 'getStatusProposta', 'vinculadoContratoOmieEmpresa']),
    validarRaizCNPJ() {
      let valido = true
      if (this.valueInner.empresas && this.valueInner.inscricaoCNPJMatriz) {
        const raiz = this.valueInner.inscricaoCNPJMatriz.replace('.', '').substring(0, 8)
        this.valueInner.empresas.forEach(each => {
          const raizFilial = each.inscricao.replace('.', '').substring(0, 8)
          if (raiz !== raizFilial) {
            valido = false
          }
        })
      }
      return valido
    },
    habilitarBotaoSalvarFaturamento() {
      return this.valueInner.eTipoFaturamentoBoletos === 2 && (this.getStatusProposta === 9 || this.getStatusProposta === 8) && !this.vinculadoContratoOmieEmpresa
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        if (this.valueInner.socios.length < 1) {
          this.adicionarItem()
        }
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    abrirRateioValores() {
      this.$refs.rateioValorContrato.showModal()
    },
    adicionarEmail(value) {
      this.valueInner.emailsBoletosNFs = value
    },
    avisoCnpjNaoFilial() {
      return this.valueInner.realizadoBusca && this.tipoProposta === 'transferencia' && this.filial && this.valueInner.empresas.some(filial => filial.matrizFilial === 'Matriz')
    },
    adicionarItem() {
      const item = {
        veioDoRFB: false,
        veioDoHub: false,
        dadosSocio: this.dadosSocio,
        tipoInscricao: 'cpf',
        cpf: null,
        ocultarDoContrato: false,
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        atualizarDados: false,
        code: generateCode(),
      }
      this.valueInner.socios.push(item)
      if (this.valueInner.socios && this.valueInner.socios.length > 1) {
        this.$emit('editar-socio')
      }
    },
    removerItem(index) {
      this.valueInner.socios.splice(index, 1)

      if (this.valueInner.socios.length === 0) {
        this.adicionarItem()
      }
      this.$emit('editar-socio')
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return erro.replace('The', '').replace('field is required', 'é um campo obrigatório')
      }
      return erro
    },
    alterarDadosContratante(mensagem) {
      this.$set(this.valueInner, 'alteracaoContratante', {
        justificativa: mensagem,
        usuCadastro: this.valueInner.alteracaoContratante.usuCadastro,
        dataCadastro: this.valueInner.alteracaoContratante.dataCadastro,
      })
      this.dadosContratante = true
    },
    alterarDadosSocio(item) {
      const socio = this.valueInner.socios.find(find => find.id === item.id)
      this.$set(socio, 'dadosSocio', true)
      this.$emit('editar-socio')
    },
    alterarDadosDataInicio(mensagem) {
      this.dadosDataInicio = true
      this.$set(this.valueInner, 'altercaoDataInicio', {
        justificativa: mensagem,
        usuCadastro: this.valueInner.altercaoDataInicio.usuCadastro,
        dataCadastro: this.valueInner.altercaoDataInicio.dataCadastro,
      })
    },
    buscarDados(inscricaoBusca, empresaId) {
      // eslint-disable-next-line global-require
      const axios = require('axios')
      this.isLoading = true
      apiPreGeracao.getEmpresasPreGeracao([inscricaoBusca], empresaId || 0, axios.CancelToken)
        .then(payload => {
          this.isLoading = false
          const dados = payload.data
          // eslint-disable-next-line no-unused-vars
          this.valueInner.empresas = this.valueInner.empresas.filter(fin => fin.inscricao !== inscricaoBusca)
          this.valueInner.empresas.push(dados.empresas.find(fin => fin.inscricao === inscricaoBusca))
          this.valueInner.empresas = this.valueInner.empresas.sort().reverse()
          this.isLoading = false
          if (dados.socios && dados.socios.length > 0) {
            if (this.valueInner.socios.length > 0) {
              dados.socios.forEach(socio => {
                this.valueInner.socios.push(socio)
              })
              if (this.valueInner.socios.length !== 1) {
                this.valueInner.socios = this.valueInner.socios.filter(filter => filter.nome === '' || filter.nome !== null)
              }
            } else {
              // eslint-disable-next-line no-lonely-if
              if (dados.empresas.find(fin => fin.inscricao === inscricaoBusca).matrizFilial === 'Matriz') {
                this.valueInner.socios = dados.socios
              }
            }
          }
        }).catch(err => {
          this.isLoading = false
          throw err
        })
    },
    buscarSocios(inscricao) {
      this.buscaSocios = true
      this.isLoading = true
      // eslint-disable-next-line global-require
      const axios = require('axios')
      if (inscricao !== '') {
        this.valueInner.primeiraBuscaMatriz = true
        apiPreGeracao.getSociosMatriz({ cadastroFederal: inscricao, constituicao: false }, axios.CancelToken)
          .then(payload => {
            const dados = payload.data
            this.isLoading = false
            this.valueInner.erroNavegacaoMatriz = (dados.empresas && dados.empresas.length > 0 && dados.empresas.some(some => some.matrizFilial === 'Filial' || !some.matrizFilial))
            this.valueInner.socios = this.valueInner.socios.filter(filt => !filt.veioDoRFB && !filt.veioDoHub)

            if (dados.socios && dados.socios.length > 0) {
              if (this.valueInner.socios.length > 0) {
                dados.socios.forEach(socio => {
                  this.valueInner.socios.push(socio)
                })
                if (this.valueInner.socios !== 1) {
                  this.valueInner.socios = this.valueInner.socios.filter(filter => filter.nome === '' || filter.nome !== null)
                }
              } else {
                this.valueInner.socios = dados.socios
              }
            } else if (this.valueInner.socios.length < 1) {
              this.adicionarItem()
            }
          }).catch(err => {
            this.isLoading = false
            throw err
          })
      }
    },
    mudadoCNPJ(valor) {
      this.$set(valor, 'atualizar', true)
    },
    alterarDadosCNPJ(mensagem) {
      this.$set(this.valueInner, 'alteracaoCNPJMatriz', {
        justificativa: mensagem,
        usuCadastro: this.valueInner.alteracaoContratante.usuCadastro,
        dataCadastro: this.valueInner.alteracaoContratante.dataCadastro,
      })
      this.dadosCNPJMatriz = true
    },
    retornaTodosArquivos() {
      const arquivos = []
      for (let index = 0; index < this.valueInner.socios.length; index += 1) {
        const { code } = this.valueInner.socios[index]
        if (this.$refs[`socio${code}`][0]) {
          const arquivo = this.$refs[`socio${code}`][0].$refs[`upload${code}`].value[0]
          if (arquivo) {
            arquivos.push({
              file: arquivo.file,
              nome: `${code};${arquivo.filename || arquivo.name}`,
            })
          }
        }
      }
      return arquivos
    },
    onTagState(valid, invalid, duplicate) {
      this.invalidTags = invalid
      this.duplicateTags = duplicate
    },
    validator(tag) {
      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
    mudarParaLowerCase(value) {
      const emails = []
      value.forEach(each => emails.push(each.toLowerCase()))
      this.valueInner.emailsBoletosNFs = emails
    },
    cancelarBusca() {
      this.$emit('closeInCancel')
      this.isLoading = false
      this.valueInner.realizadoBusca = true
      apiPreGeracao.cancelarBusca()
    },
    salvarEscolhaFaturamento() {
      apiPreGeracao.salvarEscolhaFaturamento(this.propostaId, this.valueInner)
        .then(() => {
          this.dadosDataInicio = false
          this.$sucesso('Escolha de faturamento salvo com sucesso!')
        })
    },
    ocultarSocioPregeracao() {
      this.$emit('editar-socio')
    },
  },
}
</script>
